<template>
  <UiButton
    appearance="outline-emphasis"
    size="xs"
    to="mailto:dpa-news-hub@dpa.com"
    @click="emit('itemClicked')">
    {{ t("navigation.feedback") }}
  </UiButton>
</template>

<script lang="ts" setup>
import UiButton from "@dpa-id-components/dpa-shared-components/src/components/UiButton/UiButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const emit = defineEmits<{
  itemClicked: [];
}>();
</script>
